var map = {
	"../../../../libs/modules/src/agency/agency.module": [
		"../../libs/modules/src/agency/agency.module.ts"
	],
	"../../../../libs/modules/src/assign/assign.module": [
		"../../libs/modules/src/assign/assign.module.ts"
	],
	"../../../../libs/modules/src/audits/audits.module": [
		"../../libs/modules/src/audits/audits.module.ts"
	],
	"../../../../libs/modules/src/avelon-incidences-reception/avelon-incidences-reception.module": [
		"../../libs/modules/src/avelon-incidences-reception/avelon-incidences-reception.module.ts"
	],
	"../../../../libs/modules/src/brands-enabled-reception/brands-enabled-reception.module": [
		"../../libs/modules/src/brands-enabled-reception/brands-enabled-reception.module.ts"
	],
	"../../../../libs/modules/src/building/building.module": [
		"../../libs/modules/src/building/building.module.ts"
	],
	"../../../../libs/modules/src/calendar-picking//calendar-picking.module": [
		"../../libs/modules/src/calendar-picking/calendar-picking.module.ts"
	],
	"../../../../libs/modules/src/calendar-sga//calendar-sga.module": [
		"../../libs/modules/src/calendar-sga/calendar-sga.module.ts"
	],
	"../../../../libs/modules/src/commercial-fields/commercial-fields.module": [
		"../../libs/modules/src/commercial-fields/commercial-fields.module.ts"
	],
	"../../../../libs/modules/src/customers/customers.module": [
		"../../libs/modules/src/customers/customers.module.ts"
	],
	"../../../../libs/modules/src/damaged-shoes/damaged-shoes.module": [
		"../../libs/modules/src/damaged-shoes/damaged-shoes.module.ts"
	],
	"../../../../libs/modules/src/defective-historic/defective-historic.module": [
		"../../libs/modules/src/defective-historic/defective-historic.module.ts"
	],
	"../../../../libs/modules/src/defective-management/defective-management.module": [
		"../../libs/modules/src/defective-management/defective-management.module.ts"
	],
	"../../../../libs/modules/src/defective-registry/defective-registry.module": [
		"../../libs/modules/src/defective-registry/defective-registry.module.ts"
	],
	"../../../../libs/modules/src/defective-zones/defective-zones.module": [
		"../../libs/modules/src/defective-zones/defective-zones.module.ts"
	],
	"../../../../libs/modules/src/drop-files/drop-files.module": [
		"../../libs/modules/src/drop-files/drop-files.module.ts"
	],
	"../../../../libs/modules/src/expedition-cancelled/expedition-cancelled.module": [
		"../../libs/modules/src/expedition-cancelled/expedition-cancelled.module.ts"
	],
	"../../../../libs/modules/src/expedition-collected/expedition-collected.module": [
		"../../libs/modules/src/expedition-collected/expedition-collected.module.ts"
	],
	"../../../../libs/modules/src/expedition-incidences/expedition-incidences.module": [
		"../../libs/modules/src/expedition-incidences/expedition-incidences.module.ts"
	],
	"../../../../libs/modules/src/expedition-manual/expedition-manual.module": [
		"../../libs/modules/src/expedition-manual/expedition-manual.module.ts"
	],
	"../../../../libs/modules/src/expeditions-inside/expedition-inside.module": [
		"../../libs/modules/src/expeditions-inside/expedition-inside.module.ts"
	],
	"../../../../libs/modules/src/global-variables/global-variables.module": [
		"../../libs/modules/src/global-variables/global-variables.module.ts"
	],
	"../../../../libs/modules/src/group-to-warehouse/group-to-warehouse.module": [
		"../../libs/modules/src/group-to-warehouse/group-to-warehouse.module.ts"
	],
	"../../../../libs/modules/src/group-warehouse-picking/group-warehouse-picking.module": [
		"../../libs/modules/src/group-warehouse-picking/group-warehouse-picking.module.ts"
	],
	"../../../../libs/modules/src/groups/groups.module": [
		"../../libs/modules/src/groups/groups.module.ts"
	],
	"../../../../libs/modules/src/halls/halls.module": [
		"../../libs/modules/src/halls/halls.module.ts"
	],
	"../../../../libs/modules/src/hiring-correosexpress/hiring-correosexpress.module": [
		"../../libs/modules/src/hiring-correosexpress/hiring-correosexpress.module.ts"
	],
	"../../../../libs/modules/src/hiring-dhl/hiring-dhl.module": [
		"../../libs/modules/src/hiring-dhl/hiring-dhl.module.ts"
	],
	"../../../../libs/modules/src/hiring-seur/hiring-seur.module": [
		"../../libs/modules/src/hiring-seur/hiring-seur.module.ts"
	],
	"../../../../libs/modules/src/home/home.module": [
		"../../libs/modules/src/home/home.module.ts"
	],
	"../../../../libs/modules/src/in-scans-incidences/in-scans-incidences.module": [
		"../../libs/modules/src/in-scans-incidences/in-scans-incidences.module.ts"
	],
	"../../../../libs/modules/src/incidences-list/incidences-list.module": [
		"../../libs/modules/src/incidences-list/incidences-list.module.ts"
	],
	"../../../../libs/modules/src/incidences-reception-list/incidences-reception-list.module": [
		"../../libs/modules/src/incidences-reception-list/incidences-reception-list.module.ts"
	],
	"../../../../libs/modules/src/installed-app-versions/installed-app-versions.module": [
		"../../libs/modules/src/installed-app-versions/installed-app-versions.module.ts"
	],
	"../../../../libs/modules/src/jail/jail.module": [
		"../../libs/modules/src/jail/jail.module.ts"
	],
	"../../../../libs/modules/src/labels/labels.module": [
		"../../libs/modules/src/labels/labels.module.ts"
	],
	"../../../../libs/modules/src/list-new-products/list-new-products.module": [
		"../../libs/modules/src/list-new-products/list-new-products.module.ts"
	],
	"../../../../libs/modules/src/locations/locations.module": [
		"../../libs/modules/src/locations/locations.module.ts"
	],
	"../../../../libs/modules/src/login/login.module": [
		"../../libs/modules/src/login/login.module.ts"
	],
	"../../../../libs/modules/src/marketplaces/marketplaces.module": [
		"../../libs/modules/src/marketplaces/marketplaces.module.ts"
	],
	"../../../../libs/modules/src/new-return/new-return.module": [
		"../../libs/modules/src/new-return/new-return.module.ts"
	],
	"../../../../libs/modules/src/orders/online/change-address/change-address.module": [
		"../../libs/modules/src/orders/online/change-address/change-address.module.ts"
	],
	"../../../../libs/modules/src/out-scans-incidences/out-scans-incidences.module": [
		"../../libs/modules/src/out-scans-incidences/out-scans-incidences.module.ts"
	],
	"../../../../libs/modules/src/package-history/package-history.module": [
		"../../libs/modules/src/package-history/package-history.module.ts"
	],
	"../../../../libs/modules/src/pallets/pallets.module": [
		"../../libs/modules/src/pallets/pallets.module.ts"
	],
	"../../../../libs/modules/src/permissions/permissions.module": [
		"../../libs/modules/src/permissions/permissions.module.ts"
	],
	"../../../../libs/modules/src/predistributions/predistributions.module": [
		"../../libs/modules/src/predistributions/predistributions.module.ts"
	],
	"../../../../libs/modules/src/prices/prices.module": [
		"../../libs/modules/src/prices/prices.module.ts"
	],
	"../../../../libs/modules/src/products-avelon/products-avelon.module": [
		"../../libs/modules/src/products-avelon/products-avelon.module.ts"
	],
	"../../../../libs/modules/src/products/products.module": [
		"../../libs/modules/src/products/products.module.ts"
	],
	"../../../../libs/modules/src/reception-final/reception-final.module": [
		"../../libs/modules/src/reception-final/reception-final.module.ts"
	],
	"../../../../libs/modules/src/reception-hide-alert/reception-hide-alert.module": [
		"../../libs/modules/src/reception-hide-alert/reception-hide-alert.module.ts"
	],
	"../../../../libs/modules/src/receptions-avelon/receptions-avelon.module": [
		"../../libs/modules/src/receptions-avelon/receptions-avelon.module.ts"
	],
	"../../../../libs/modules/src/receptionss-avelon/receptionss-avelon.module": [
		"../../libs/modules/src/receptionss-avelon/receptionss-avelon.module.ts"
	],
	"../../../../libs/modules/src/refunds/refunds.module": [
		"../../libs/modules/src/refunds/refunds.module.ts"
	],
	"../../../../libs/modules/src/regions/regions.module": [
		"../../libs/modules/src/regions/regions.module.ts"
	],
	"../../../../libs/modules/src/return-tracking-list/return-tracking-list.module": [
		"../../libs/modules/src/return-tracking-list/return-tracking-list.module.ts"
	],
	"../../../../libs/modules/src/return-types/return-types.module": [
		"../../libs/modules/src/return-types/return-types.module.ts"
	],
	"../../../../libs/modules/src/returns-historic/returns-historic.module": [
		"../../libs/modules/src/returns-historic/returns-historic.module.ts"
	],
	"../../../../libs/modules/src/returns-list-products/returns-list-products.module": [
		"../../libs/modules/src/returns-list-products/returns-list-products.module.ts"
	],
	"../../../../libs/modules/src/returns-list/returns-list.module": [
		"../../libs/modules/src/returns-list/returns-list.module.ts"
	],
	"../../../../libs/modules/src/role-assignment/role-assignment.module": [
		"../../libs/modules/src/role-assignment/role-assignment.module.ts"
	],
	"../../../../libs/modules/src/roles/roles.module": [
		"../../libs/modules/src/roles/roles.module.ts"
	],
	"../../../../libs/modules/src/seasons-enabled/seasons-enabled.module": [
		"../../libs/modules/src/seasons-enabled/seasons-enabled.module.ts"
	],
	"../../../../libs/modules/src/sorter-create/sorter-create.module": [
		"../../libs/modules/src/sorter-create/sorter-create.module.ts"
	],
	"../../../../libs/modules/src/sorter/sorter.module": [
		"../../libs/modules/src/sorter/sorter.module.ts"
	],
	"../../../../libs/modules/src/state-expedition-avelon/state-expedition-avelon.module": [
		"../../libs/modules/src/state-expedition-avelon/state-expedition-avelon.module.ts"
	],
	"../../../../libs/modules/src/supplier-conditions/supplier-conditions.module": [
		"../../libs/modules/src/supplier-conditions/supplier-conditions.module.ts"
	],
	"../../../../libs/modules/src/tariffSGA/tariffSGA.module": [
		"../../libs/modules/src/tariffSGA/tariffSGA.module.ts"
	],
	"../../../../libs/modules/src/transports-expeditions/transports-expeditions.module": [
		"../../libs/modules/src/transports-expeditions/transports-expeditions.module.ts"
	],
	"../../../../libs/modules/src/transports-orders/transports-orders.module": [
		"../../libs/modules/src/transports-orders/transports-orders.module.ts"
	],
	"../../../../libs/modules/src/user-assignment-picking/user-assignment-picking.module": [
		"../../libs/modules/src/user-assignment-picking/user-assignment-picking.module.ts"
	],
	"../../../../libs/modules/src/user-manager/user-manager.module": [
		"../../libs/modules/src/user-manager/user-manager.module.ts"
	],
	"../../../../libs/modules/src/user-time/user-time.module": [
		"../../libs/modules/src/user-time/user-time.module.ts"
	],
	"../../../../libs/modules/src/users/users.module": [
		"../../libs/modules/src/users/users.module.ts"
	],
	"../../../../libs/modules/src/warehouses/warehouses.module": [
		"../../libs/modules/src/warehouses/warehouses.module.ts"
	],
	"../../../../libs/modules/src/workwave-config-menu/workwave-config-menu.module": [
		"../../libs/modules/src/workwave-config-menu/workwave-config-menu.module.ts"
	],
	"../../../../libs/modules/src/workwave-template-online-store/workwave-template-online-store.module": [
		"../../libs/modules/src/workwave-template-online-store/workwave-template-online-store.module.ts"
	],
	"../../../../libs/modules/src/workwave-template-rebuild/workwave-template-rebuild.module": [
		"../../libs/modules/src/workwave-template-rebuild/workwave-template-rebuild.module.ts"
	],
	"../../../../libs/modules/src/workwaves-history/workwaves-history.module": [
		"../../libs/modules/src/workwaves-history/workwaves-history.module.ts"
	],
	"../../../../libs/modules/src/workwaves-schedule/workwaves-schedule.module": [
		"../../libs/modules/src/workwaves-schedule/workwaves-schedule.module.ts"
	],
	"./welcome/welcome.module": [
		"./src/app/welcome/welcome.module.ts",
		"welcome-welcome-module"
	],
	"@suite/common-modules": [
		"../../libs/modules/src/locations/locations.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;